import { useEffect, useRef, useState } from "react";

const WARN_MS = 30 * 60 * 1000;   // 30 minutes idle → show warning
const LOGOUT_MS = 60 * 60 * 1000; // 60 minutes idle → logout

export default function useIdleTimeout(onLogout) {
  const [showWarning, setShowWarning] = useState(false);
  const warnTimer = useRef(null);
  const logoutTimer = useRef(null);

  const reset = () => {
    setShowWarning(false);
    clearTimeout(warnTimer.current);
    clearTimeout(logoutTimer.current);
    warnTimer.current = setTimeout(() => setShowWarning(true), WARN_MS);
    logoutTimer.current = setTimeout(() => {
      setShowWarning(false);
      onLogout();
    }, LOGOUT_MS);
  };

  useEffect(() => {
    const events = ["mousedown", "mousemove", "keydown", "touchstart", "scroll"];
    events.forEach(e => window.addEventListener(e, reset, { passive: true }));
    reset();
    return () => {
      events.forEach(e => window.removeEventListener(e, reset));
      clearTimeout(warnTimer.current);
      clearTimeout(logoutTimer.current);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const stayLoggedIn = () => reset();

  return { showWarning, stayLoggedIn };
}
